import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_176 implements Validator {

	public static id = 'CTRL_176';
	private message = 'error.ctr_176';


	public LOG: LogService = new LogService(CTRL_176);
	public formExtractorService: FormExtractorService = new FormExtractorService();


	validate(form: any, map) {


		// vérifier si la règle est applicable sur mon formulaire
		const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_176.id + '_');


		if (rgs.length > 0) {
			for (const rg of rgs) {
				const ctrl = form.controls[rg];

				const lieuNumWithStepId = map.get(ctrl.value.rgCtrls.lieuNum);
                const lieuNomWithStepId = map.get(ctrl.value.rgCtrls.lieuNom);
                const lieuTypeVoieWithStepId = map.get(ctrl.value.rgCtrls.lieuTypeVoie);
                const lieuNumCtrl = form.controls[lieuNumWithStepId]?.value;
                const lieuNomCtrl = form.controls[lieuNomWithStepId]?.value;
                const lieuTypeVoieCtrl = form.controls[lieuTypeVoieWithStepId]?.value;

				let lieu = (lieuNumCtrl?.length || 0) + (lieuNomCtrl?.length || 0)  + (lieuTypeVoieCtrl?.length || 0);
				
				if (lieu > 0 && lieu < 5 ) {
					// placer le message d'erreur
					form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
				} else {
					form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
				}
			}
		}
	}
}
